import React from 'react';
import useScrollDirection from '../hooks/useScrollDirection';

/**
 *
 * @param WrappedComponent
 * @param {number} topOffsetThreshold For how many pixels we should ignore the
 *   scroll direction, usually for sticky headers, the header's height.
 * @param bottomOffsetThreshold
 * @param scrollUpThreshold
 */
export default function withScrollDirection(WrappedComponent, topOffsetThreshold = 0, bottomOffsetThreshold = 0, scrollUpThreshold = 400) {
  return function(props) {
    const scrollDirection = useScrollDirection(topOffsetThreshold, bottomOffsetThreshold, scrollUpThreshold);

    return (
      <WrappedComponent scrollDirection={scrollDirection} {...props} />
    );
  };
}
